module.exports = __webpack_public_path__ + "assets/img/f71d069dd88015772d244833bc783144.png";